import { Variants } from 'framer-motion';

export const containerVariants: Variants = {
  animate: {
    transition: {
      staggerChildren: 0.02,
      delayChildren: 0.005,
    },
  },
};

export const productVariants: Variants = {
  initial: { opacity: 0 },
  animate: {
    opacity: 1,
    transition: { duration: 0.175, ease: [0.4, 0, 0.2, 1] },
  },
  exit: {
    opacity: 0,
    transition: { duration: 0.1, ease: [0.4, 0, 0.2, 1] },
  },
};
